const Loader = () => (
  <div className="loader">
    <h1>Loading</h1>
  </div>
);

export default Loader;
